<template>
  <div>
    <template v-if="editionMode">
      <div :class="containerClasses">
        <Listbox v-model="cType">
          <label v-if="label" :for="name" :class="labelClasses"
            >{{ label }}
            <span v-if="required" class="text-red-500">*</span>
          </label>
          <input v-model="cReduction" :class="inputClasses" type="text" />
          <div :class="typeContainerClasses">
            <ListboxButton
              v-if="initialMetadata?.enums?.amount_types.length > 0"
              :class="buttonClasses"
              tabindex="-1"
            >
              <span v-if="cType">{{
                cType === AmountTypes.PERCENT ? '%' : '€'
              }}</span>
            </ListboxButton>
          </div>

          <transition
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <ListboxOptions :class="listboxOptionsClasses">
              <ListboxOption
                v-for="(item, index) in initialMetadata?.enums?.amount_types"
                :key="index"
                :value="item.id"
                as="template"
              >
                <li :class="listItemClasses">
                  <div :class="listItemContentClasses">
                    <span :class="listItemContentInnerClasses">
                      {{ item.name.toLowerCase() === 'percent' ? '%' : '€' }}
                    </span>
                  </div>
                </li>
              </ListboxOption>
            </ListboxOptions>
          </transition>
        </Listbox>
      </div>
      <ErrorContainer :error-key="name" :errors="errors" />
    </template>
    <template v-else>
      <div class="relative w-full">
        <BaseShowLabel
          :label="label"
          :model-value="reduction"
          class="bg-gray-50"
        />
        <span
          class="absolute inset-y-0 right-3 flex flex-row items-center font-semibold"
        >
          {{ cType === AmountTypes.PERCENT ? '%' : '€' }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions
} from '@headlessui/vue'
import { mapGetters } from 'vuex'
import ErrorContainer from '@c/addf-package/components/BaseShowEditInput/ErrorContainer.vue'
import AmountTypes from '@/assets/enums/invoicing/AmountTypes'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'

export default {
  name: 'ReductionTypeComponent',
  components: {
    BaseShowLabel,
    ErrorContainer,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption
  },
  props: {
    editionMode: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: '',
      require: true
    },
    reduction: {
      type: String,
      required: true
    },
    type: {
      type: Object,
      required: true
    },
    errors: {
      type: Array,
      default() {
        return []
      }
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:type', 'update:reduction'],
  data() {
    return {
      AmountTypes: AmountTypes
    }
  },
  computed: {
    ...mapGetters({
      initialMetadata: 'metadata/getInitialMetadata'
    }),
    containerClasses() {
      return {
        'relative flex flex-row rounded-md border border-slate-300 shadow-sm focus-within:border-primary-400 focus-within:ring-0': true,
        'mt-2': !!this.label
      }
    },
    labelClasses() {
      return {
        'absolute -top-2 left-2 z-10 -mt-px inline-block rounded-md bg-white/75 px-1 text-xs font-medium text-gray-900 capitalize-first': true
      }
    },
    inputClasses() {
      return {
        'block flex-1 rounded-md border-0 p-0 px-10 py-2 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm': true
      }
    },
    typeContainerClasses() {
      return {
        'absolute inset-y-2 right-0 flex flex-row items-center pr-1.5': true
      }
    },
    buttonClasses() {
      return {
        'txt-white rounded bg-slate-300 px-1.5 py-1 text-xs text-gray-700': true
      }
    },
    listboxOptionsClasses() {
      return {
        'absolute right-0 z-50 mt-10 flex max-h-60 w-10 flex-col gap-1 overflow-auto rounded-md border border-slate-300 bg-white p-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm': true
      }
    },
    listItemClasses() {
      return {
        'relative cursor-pointer rounded-md py-3 my-0.5 w-full bg-red-200': true
      }
    },
    listItemContentClasses() {
      return {
        'absolute inset-0 flex flex-row items-center': true
      }
    },
    listItemContentInnerClasses() {
      return {
        'rounded-md bg-slate-300 px-1 py-0.5 text-gray-700 w-full text-center': true
      }
    },
    cType: {
      get: function () {
        return this.type
      },
      set: function (newValue) {
        this.$emit('update:type', newValue)
      }
    },
    cReduction: {
      get: function () {
        return this.reduction
      },
      set: function (newValue) {
        this.$emit('update:reduction', newValue)
      }
    }
  },
  mounted() {
    this.cType = this.cType ?? AmountTypes.PERCENT
  },
  methods: {}
}
</script>
